var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isInit && _vm.employee
    ? _c(
        "div",
        [
          _c(
            "vs-row",
            { staticClass: "employee_info" },
            [
              _c(
                "vs-alert",
                {
                  staticClass: "mb-8",
                  attrs: {
                    active:
                      !_vm.currentRating.length &&
                      !_vm.currentSkillReviews.length,
                    "icon-pack": "feather",
                    icon: "icon-alert-triangle",
                    color: "warning",
                  },
                },
                [
                  _vm._v(
                    "\n            Vous n'avez pas encore évalué cette personne.\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "vs-col",
                [
                  _c(
                    "vs-row",
                    { staticClass: "mb-10" },
                    [
                      _vm.employee
                        ? _c("vs-col", { attrs: { "vs-lg": "4" } }, [
                            _c("ul", { staticClass: "employee-info" }, [
                              _c(
                                "li",
                                { staticClass: "employee-name" },
                                [
                                  _vm.employee.photoUrl
                                    ? _c("vs-avatar", {
                                        attrs: {
                                          size: "50px",
                                          src: _vm.employee.photoUrl,
                                        },
                                      })
                                    : _c("vs-avatar", {
                                        attrs: {
                                          size: "50px",
                                          color: _vm.generateColor(
                                            _vm.employee.name
                                          ),
                                        },
                                      }),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("b", { staticClass: "uppercase" }, [
                                      _vm._v(_vm._s(_vm.employee.last_name)),
                                    ]),
                                    _vm._v(" "),
                                    _c("b", [
                                      _vm._v(_vm._s(_vm.employee.first_name)),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                { staticClass: "employee-structure" },
                                [
                                  _c("p", [_vm._v("Etablissements:")]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.employee.active_establishments,
                                    function (el, index) {
                                      return _c(
                                        "ms-chip",
                                        {
                                          key: index,
                                          attrs: {
                                            transparent: "",
                                            color: "#333",
                                          },
                                        },
                                        [_c("b", [_vm._v(_vm._s(el.name))])]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                { staticClass: "employee-structure" },
                                [
                                  _c("p", [_vm._v("Service(s) de référence:")]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.employee.active_services,
                                    function (el, index) {
                                      return _c(
                                        "ms-chip",
                                        {
                                          key: index,
                                          attrs: {
                                            transparent: "",
                                            color: "#333",
                                          },
                                        },
                                        [_c("b", [_vm._v(_vm._s(el.title))])]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "vs-col",
                        {
                          staticClass: "action-buttons",
                          attrs: { "vs-lg": "8" },
                        },
                        [
                          _c(
                            "vs-row",
                            { attrs: { "vs-justify": "flex-end" } },
                            [
                              _vm.canContinueSkillReview
                                ? _c(
                                    "vs-button",
                                    {
                                      attrs: {
                                        id: "addBilan",
                                        color: "primary",
                                        type: "border",
                                        "icon-pack": "feather",
                                        icon: "icon-check-square",
                                      },
                                      on: {
                                        click: _vm.redirectSkillReviewContinue,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Poursuivre le " +
                                          _vm._s(
                                            _vm.skillRatingNames.singular.toLowerCase()
                                          ) +
                                          " en cours\n                        "
                                      ),
                                    ]
                                  )
                                : _vm.canAddSkillReview
                                ? _c(
                                    "vs-button",
                                    {
                                      attrs: {
                                        id: "addBilan",
                                        color: "primary",
                                        type: "border",
                                        "icon-pack": "feather",
                                        icon: "icon-check-square",
                                      },
                                      on: {
                                        click: _vm.redirectSkillReviewCreation,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Créer un " +
                                          _vm._s(
                                            _vm.skillRatingNames.singular.toLowerCase()
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.canModifySkillReview
                                ? _c(
                                    "vs-button",
                                    {
                                      attrs: {
                                        id: "modifyRating",
                                        color: "primary",
                                        type: "border",
                                        "icon-pack": "feather",
                                        icon: "icon-edit",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.editSkillRatingPrompt = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Modifier un " +
                                          _vm._s(
                                            _vm.skillRatingNames.singular.toLowerCase()
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "DialogPrompt",
                                {
                                  attrs: {
                                    active: _vm.editSkillRatingPrompt,
                                    title: `Modifier un ${_vm.skillRatingNames.singular} non validé`,
                                    "cancel-text": "Annuler",
                                    "accept-text": "Modifier",
                                    "is-valid": true,
                                  },
                                  on: {
                                    "update:active": function ($event) {
                                      _vm.editSkillRatingPrompt = $event
                                    },
                                    cancel: _vm.cancelEditSkillRating,
                                    close: _vm.cancelEditSkillRating,
                                    accept: _vm.redirectSkillReviewEdition,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "con-exemple-prompt" },
                                    [
                                      _c("multiselect", {
                                        attrs: {
                                          label: "rating_date",
                                          options: _vm.unvalidatedSkillReview,
                                          placeholder: "Recherche ...",
                                          "select-label": "",
                                          "select-group-label": "",
                                          "selected-label": "",
                                          "deselect-label": "",
                                          "deselect-group-label": "",
                                        },
                                        model: {
                                          value: _vm.editedSkillRating,
                                          callback: function ($$v) {
                                            _vm.editedSkillRating = $$v
                                          },
                                          expression: "editedSkillRating",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.canDeleteSkillReview
                                ? _c(
                                    "vs-button",
                                    {
                                      attrs: {
                                        id: "deleteSkillReview",
                                        color: "primary",
                                        type: "border",
                                        "icon-pack": "feather",
                                        icon: "icon-trash",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.deleteSkillRatingPrompt = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Supprimer un " +
                                          _vm._s(
                                            _vm.skillRatingNames.singular
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "DialogPrompt",
                                {
                                  attrs: {
                                    active: _vm.deleteSkillRatingPrompt,
                                    title: `Supprimer un ${_vm.skillRatingNames.singular}`,
                                    "cancel-text": "Annuler",
                                    "accept-text": "Supprimer",
                                    "is-valid": true,
                                  },
                                  on: {
                                    "update:active": function ($event) {
                                      _vm.deleteSkillRatingPrompt = $event
                                    },
                                    cancel: _vm.cancelDeleteSkillRating,
                                    close: _vm.cancelDeleteSkillRating,
                                    accept: _vm.deleteSkillRating,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "con-exemple-prompt" },
                                    [
                                      _c("multiselect", {
                                        attrs: {
                                          label: "rating_date",
                                          options: _vm.deletableSkillReview,
                                          placeholder: "Recherche ...",
                                          "select-label": "",
                                          "select-group-label": "",
                                          "selected-label": "",
                                          "deselect-label": "",
                                          "deselect-group-label": "",
                                        },
                                        model: {
                                          value: _vm.deletedSkillRating,
                                          callback: function ($$v) {
                                            _vm.deletedSkillRating = $$v
                                          },
                                          expression: "deletedSkillRating",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.canContinueRating
                                ? _c(
                                    "vs-button",
                                    {
                                      attrs: {
                                        color: "primary",
                                        type: "border",
                                        "icon-pack": "feather",
                                        icon: "icon-check-square",
                                      },
                                      on: { click: _vm.redirectPursue },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Poursuivre le " +
                                          _vm._s(
                                            _vm.projectNames.singular.toLowerCase()
                                          ) +
                                          " en cours\n                        "
                                      ),
                                    ]
                                  )
                                : _vm.canAddRating
                                ? _c(
                                    "vs-button",
                                    {
                                      attrs: {
                                        id: "addRating",
                                        color: "primary",
                                        type: "border",
                                        "icon-pack": "feather",
                                        icon: "icon-check-square",
                                      },
                                      on: { click: _vm.redirectCreation },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Ajouter un " +
                                          _vm._s(
                                            _vm.projectNames.singular.toLowerCase()
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.canModifyRating
                                ? _c(
                                    "vs-button",
                                    {
                                      attrs: {
                                        id: "modifyRating",
                                        color: "primary",
                                        type: "border",
                                        "icon-pack": "feather",
                                        icon: "icon-edit",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.editRatingPrompt = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Modifier un " +
                                          _vm._s(
                                            _vm.projectNames.singular.toLowerCase()
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "DialogPrompt",
                                {
                                  attrs: {
                                    active: _vm.editRatingPrompt,
                                    title: `Modifier un ${_vm.projectNames.singular} non validé`,
                                    "cancel-text": "Annuler",
                                    "accept-text": "Modifier",
                                    "is-valid": true,
                                  },
                                  on: {
                                    "update:active": function ($event) {
                                      _vm.editRatingPrompt = $event
                                    },
                                    cancel: _vm.cancelEditRating,
                                    close: _vm.cancelEditRating,
                                    accept: _vm.redirectEdition,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "con-exemple-prompt" },
                                    [
                                      _c("multiselect", {
                                        attrs: {
                                          label: "rating_date",
                                          options: _vm.unvalidatedRatings,
                                          placeholder: "Recherche ...",
                                          "select-label": "",
                                          "select-group-label": "",
                                          "selected-label": "",
                                          "deselect-label": "",
                                          "deselect-group-label": "",
                                        },
                                        model: {
                                          value: _vm.editedRating,
                                          callback: function ($$v) {
                                            _vm.editedRating = $$v
                                          },
                                          expression: "editedRating",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.canDeleteRating
                                ? _c(
                                    "vs-button",
                                    {
                                      attrs: {
                                        id: "deleteRating",
                                        color: "primary",
                                        type: "border",
                                        "icon-pack": "feather",
                                        icon: "icon-trash",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.deleteRatingPrompt = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Supprimer un " +
                                          _vm._s(_vm.projectNames.singular) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "DialogPrompt",
                                {
                                  attrs: {
                                    active: _vm.deleteRatingPrompt,
                                    title: `Supprimer un ${_vm.projectNames.singular}`,
                                    "cancel-text": "Annuler",
                                    "accept-text": "Supprimer",
                                    "is-valid": true,
                                  },
                                  on: {
                                    "update:active": function ($event) {
                                      _vm.deleteRatingPrompt = $event
                                    },
                                    cancel: _vm.cancelDeleteRating,
                                    close: _vm.cancelDeleteRating,
                                    accept: _vm.deleteRating,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "con-exemple-prompt" },
                                    [
                                      _c("multiselect", {
                                        attrs: {
                                          label: "rating_date",
                                          options: _vm.deletableRating,
                                          placeholder: "Recherche ...",
                                          "select-label": "",
                                          "select-group-label": "",
                                          "selected-label": "",
                                          "deselect-label": "",
                                          "deselect-group-label": "",
                                        },
                                        model: {
                                          value: _vm.deletedRating,
                                          callback: function ($$v) {
                                            _vm.deletedRating = $$v
                                          },
                                          expression: "deletedRating",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.canExportRating
                                ? _c(
                                    "vs-button",
                                    {
                                      class: [
                                        "vs-con-loading__container",
                                        {
                                          exportPDF:
                                            "vs-con-loading__container",
                                        },
                                      ],
                                      attrs: {
                                        id: "export-pdf-button",
                                        color: "primary",
                                        type: "border",
                                        "icon-pack": "feather",
                                        icon: "icon-download",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.exportRatingPrompt = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Export\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "DialogPrompt",
                                {
                                  attrs: {
                                    active: _vm.exportRatingPrompt,
                                    title: `Exporter une évaluation`,
                                    "cancel-text": "Annuler",
                                    "accept-text": "Exporter",
                                    "is-valid": _vm.isValidExport,
                                  },
                                  on: {
                                    "update:active": function ($event) {
                                      _vm.exportRatingPrompt = $event
                                    },
                                    cancel: _vm.cancelExportRating,
                                    close: _vm.cancelExportRating,
                                    accept: function ($event) {
                                      return _vm.initExport()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "con-exemple-prompt" },
                                    [
                                      _c(
                                        "vs-row",
                                        { staticClass: "mb-6" },
                                        [
                                          _c(
                                            "vs-col",
                                            { staticClass: "w-full" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "mb-1" },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Choisissez une évaluation*"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "multiselect",
                                                {
                                                  attrs: {
                                                    label: "title",
                                                    options: _vm.exportRating,
                                                    placeholder:
                                                      "Rechercher...",
                                                    "select-label": "",
                                                    "select-group-label": "",
                                                    "selected-label": "",
                                                    "deselect-label": "",
                                                    "deselect-group-label": "",
                                                  },
                                                  model: {
                                                    value: _vm.exportRatingDate,
                                                    callback: function ($$v) {
                                                      _vm.exportRatingDate = $$v
                                                    },
                                                    expression:
                                                      "exportRatingDate",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        slot: "noOptions",
                                                      },
                                                      slot: "noOptions",
                                                    },
                                                    [_vm._v("Aucun résultat")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "vs-row",
                                        { staticClass: "mb-6" },
                                        [
                                          _c(
                                            "vs-col",
                                            { staticClass: "w-full" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "mb-1" },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Choisissez le format*"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                _vm._l(
                                                  _vm.exportMimes,
                                                  function (mime, i) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        key: i,
                                                        staticClass: "mr-5",
                                                      },
                                                      [
                                                        _c(
                                                          "vs-radio",
                                                          {
                                                            attrs: {
                                                              "vs-name": "mime",
                                                              "vs-value":
                                                                mime.mime,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.exportMime,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.exportMime =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "exportMime",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(mime.name)
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.exportMime === ".docx"
                                        ? _c(
                                            "vs-row",
                                            { staticClass: "mb-6" },
                                            [
                                              _c(
                                                "vs-col",
                                                { staticClass: "w-full" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "mb-1" },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Choisissez un modèle*"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "Multiselect",
                                                    {
                                                      attrs: {
                                                        label: "title",
                                                        options: _vm.allModels,
                                                        placeholder:
                                                          "Rechercher...",
                                                        "select-label": "",
                                                        "select-group-label":
                                                          "",
                                                        "selected-label": "",
                                                        "deselect-label": "",
                                                        "deselect-group-label":
                                                          "",
                                                        loading:
                                                          _vm.exportModels
                                                            .loading &&
                                                          _vm.exportAdminModels
                                                            .loading,
                                                      },
                                                      model: {
                                                        value: _vm.exportValue,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.exportValue = $$v
                                                        },
                                                        expression:
                                                          "exportValue",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "noOptions",
                                                          },
                                                          slot: "noOptions",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Aucun résultat"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "vs-row",
                    [
                      _vm.can("read", "ratings")
                        ? _c(
                            "vs-row",
                            { staticClass: "mb-10" },
                            [
                              _c(
                                "vs-col",
                                {
                                  staticClass: "mb-5",
                                  attrs: { "vs-lg": "2", "vs-sm": "12" },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.projectNames.plural)),
                                  ]),
                                  _vm._v(" :\n                    "),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "vs-col",
                                { attrs: { "vs-lg": "10", "vs-sm": "12" } },
                                [
                                  _c(
                                    "multiselect",
                                    {
                                      attrs: {
                                        options: _vm.currentRating,
                                        multiple: "",
                                        placeholder: "Recherche ...",
                                        "track-by": "title",
                                        label: "title",
                                        "select-label": "",
                                        "select-group-label": "",
                                        "selected-label": "",
                                        "deselect-label": "",
                                        "deselect-group-label": "",
                                      },
                                      model: {
                                        value: _vm.selectedRatings,
                                        callback: function ($$v) {
                                          _vm.selectedRatings = $$v
                                        },
                                        expression: "selectedRatings",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "noOptions" },
                                          slot: "noOptions",
                                        },
                                        [_vm._v("Aucun résultat")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.can("read", "ratings")
                        ? _c(
                            "vs-row",
                            { staticClass: "mb-10" },
                            [
                              _c(
                                "vs-col",
                                {
                                  staticClass: "mb-5",
                                  attrs: { "vs-lg": "2", "vs-sm": "12" },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      "Auto-évaluation du " +
                                        _vm._s(_vm.projectNames.singular)
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                        :\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "vs-col",
                                { attrs: { "vs-lg": "10", "vs-sm": "12" } },
                                [
                                  _c(
                                    "multiselect",
                                    {
                                      attrs: {
                                        options: _vm.selfRatingList,
                                        placeholder: "Recherche ...",
                                        "track-by": "title",
                                        label: "title",
                                        "select-label": "",
                                        "select-group-label": "",
                                        "selected-label": "",
                                        "deselect-label": "",
                                        "deselect-group-label": "",
                                      },
                                      model: {
                                        value: _vm.selectedAutoRating,
                                        callback: function ($$v) {
                                          _vm.selectedAutoRating = $$v
                                        },
                                        expression: "selectedAutoRating",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "noOptions" },
                                          slot: "noOptions",
                                        },
                                        [_vm._v("Aucun résultat")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.can("read", "skill_reviews")
                        ? _c(
                            "vs-row",
                            { staticClass: "mb-10" },
                            [
                              _c(
                                "vs-col",
                                {
                                  staticClass: "mb-5",
                                  attrs: { "vs-lg": "2", "vs-sm": "12" },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.skillRatingNames.singular)
                                    ),
                                  ]),
                                  _vm._v(" :\n                    "),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "vs-col",
                                { attrs: { "vs-lg": "10", "vs-sm": "12" } },
                                [
                                  _c(
                                    "multiselect",
                                    {
                                      attrs: {
                                        options: _vm.currentSkillReviews,
                                        multiple: "",
                                        placeholder: "Recherche ...",
                                        "track-by": "title",
                                        label: "title",
                                        "select-label": "",
                                        "select-group-label": "",
                                        "selected-label": "",
                                        "deselect-label": "",
                                        "deselect-group-label": "",
                                      },
                                      model: {
                                        value: _vm.selectedSkillReview,
                                        callback: function ($$v) {
                                          _vm.selectedSkillReview = $$v
                                        },
                                        expression: "selectedSkillReview",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "noOptions" },
                                          slot: "noOptions",
                                        },
                                        [_vm._v("Aucun résultat")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "vs-row",
                        { staticClass: "mb-10" },
                        [
                          _c(
                            "vs-col",
                            {
                              staticClass: "mb-5",
                              attrs: { "vs-lg": "2", "vs-sm": "12" },
                            },
                            [
                              _c("strong", [_vm._v("Auto-évaluation Portail")]),
                              _vm._v(" : "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "vs-col",
                            { attrs: { "vs-lg": "10", "vs-sm": "12" } },
                            [
                              _c(
                                "multiselect",
                                {
                                  attrs: {
                                    options: _vm.mobilityRatings,
                                    multiple: "",
                                    placeholder: "Recherche ...",
                                    "track-by": "title",
                                    label: "title",
                                    "select-label": "",
                                    "select-group-label": "",
                                    "selected-label": "",
                                    "deselect-label": "",
                                    "deselect-group-label": "",
                                  },
                                  model: {
                                    value: _vm.selectedMobilityRatings,
                                    callback: function ($$v) {
                                      _vm.selectedMobilityRatings = $$v
                                    },
                                    expression: "selectedMobilityRatings",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "noOptions" },
                                      slot: "noOptions",
                                    },
                                    [_vm._v("Aucun résultat")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "vs-row",
                        { staticClass: "mb-10" },
                        [
                          _c(
                            "vs-col",
                            {
                              staticClass: "mb-5",
                              attrs: { "vs-lg": "2", "vs-sm": "12" },
                            },
                            [
                              _c("strong", [_vm._v("Evaluation(s) Portail")]),
                              _vm._v(" : "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "vs-col",
                            { attrs: { "vs-lg": "10", "vs-sm": "12" } },
                            [
                              _c(
                                "multiselect",
                                {
                                  attrs: {
                                    options: _vm.externalRatings,
                                    multiple: "",
                                    placeholder: "Recherche ...",
                                    "track-by": "title",
                                    label: "title",
                                    "select-label": "",
                                    "select-group-label": "",
                                    "selected-label": "",
                                    "deselect-label": "",
                                    "deselect-group-label": "",
                                  },
                                  model: {
                                    value: _vm.selectedExternalRatings,
                                    callback: function ($$v) {
                                      _vm.selectedExternalRatings = $$v
                                    },
                                    expression: "selectedExternalRatings",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "noOptions" },
                                      slot: "noOptions",
                                    },
                                    [_vm._v("Aucun résultat")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.employeeOccupationSkillRatingsOnly
                        ? _c(
                            "vs-row",
                            {
                              staticClass: "mb-6",
                              staticStyle: { position: "relative" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "vx-col w-full" },
                                [
                                  _c(
                                    "Carousel",
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "chart main",
                                          attrs: { id: "skills" },
                                        },
                                        [
                                          _c("rating-chart", {
                                            staticClass: "main-chart",
                                            attrs: {
                                              employee: _vm.employee,
                                              options:
                                                _vm.skillRatingChart.options,
                                              "chart-data":
                                                _vm.skillRatingChart.data,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.categories,
                                        function (category, index) {
                                          return [
                                            _vm.skillRatingChartPerCategory[
                                              category.id
                                            ]
                                              ? _c(
                                                  "div",
                                                  {
                                                    key:
                                                      "main_category_" + index,
                                                    staticClass: "chart main",
                                                    attrs: {
                                                      id:
                                                        "skills_cat_" +
                                                        category.id,
                                                    },
                                                  },
                                                  [
                                                    _c("rating-chart", {
                                                      staticClass: "main-chart",
                                                      attrs: {
                                                        employee: _vm.employee,
                                                        options:
                                                          _vm
                                                            .skillRatingChartPerCategory[
                                                            category.id
                                                          ].options,
                                                        "chart-data":
                                                          _vm
                                                            .skillRatingChartPerCategory[
                                                            category.id
                                                          ].data,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "vs-row",
            { staticClass: "charts text-primary" },
            [
              _c(
                "vs-col",
                {
                  staticStyle: { position: "relative" },
                  attrs: { "vs-w": "12" },
                },
                [
                  _c(
                    "vs-collapse",
                    [
                      _vm.showRatingsHaveOccupations
                        ? _c(
                            "vs-collapse-item",
                            {
                              attrs: {
                                open: _vm.employeeOccupationSkillRatingsOnly,
                                id: "employee-occupations-charts",
                                "icon-arrow": "arrow_downward",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "collapse-header",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "bold text-primary" },
                                    [_vm._v("Métier(s) : ")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.showRatings.length
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "vs-row",
                                        {
                                          staticClass: "mb-5",
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-w": "12",
                                          },
                                        },
                                        [
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-lg": "2",
                                                "vs-sm": "4",
                                              },
                                            },
                                            [
                                              _c(
                                                "vs-radio",
                                                {
                                                  attrs: {
                                                    id: "switchOccupationRadio_occupations",
                                                    "vs-name":
                                                      "switchOccupationRadio",
                                                    "vs-value": "occupations",
                                                    disabled:
                                                      _vm.employeeOccupationSkillRatingsOnly,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.switchOccupationsRadar,
                                                    callback: function ($$v) {
                                                      _vm.switchOccupationsRadar =
                                                        $$v
                                                    },
                                                    expression:
                                                      "switchOccupationsRadar",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    Accessibilité\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-lg": "2",
                                                "vs-sm": "4",
                                              },
                                            },
                                            [
                                              _c(
                                                "vs-radio",
                                                {
                                                  attrs: {
                                                    id: "switchOccupationRadio_occupationSkills",
                                                    "vs-name":
                                                      "switchOccupationRadio",
                                                    "vs-value":
                                                      "occupationSkills",
                                                    disabled:
                                                      _vm.employeeOccupationSkillRatingsOnly,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.switchOccupationsRadar,
                                                    callback: function ($$v) {
                                                      _vm.switchOccupationsRadar =
                                                        $$v
                                                    },
                                                    expression:
                                                      "switchOccupationsRadar",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    Savoir-faire\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "vs-col",
                                            {
                                              staticClass: "flex",
                                              attrs: {
                                                "vs-lg": "2",
                                                "vs-sm": "4",
                                              },
                                            },
                                            [
                                              _c(
                                                "vs-radio",
                                                {
                                                  attrs: {
                                                    id: "switchOccupationRadio_occupationSkillsLevels",
                                                    "vs-name":
                                                      "switchOccupationRadio",
                                                    "vs-value":
                                                      "occupationSkillsLevels",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.switchOccupationsRadar,
                                                    callback: function ($$v) {
                                                      _vm.switchOccupationsRadar =
                                                        $$v
                                                    },
                                                    expression:
                                                      "switchOccupationsRadar",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    Maîtrise savoir-faire\n                                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "ms-tooltip",
                                                    {
                                                      attrs: {
                                                        text: "Le score de maîtrise est la moyenne des savoir-faire maîtrisés pondérée suivant le niveau de maîtrise",
                                                        position: "right",
                                                      },
                                                    },
                                                    [
                                                      _c("vs-button", {
                                                        staticClass:
                                                          "large-icon",
                                                        attrs: {
                                                          radius: "",
                                                          color: "primary",
                                                          type: "flat",
                                                          icon: "info",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.switchOccupationsRadar ===
                                      "occupations"
                                        ? _c(
                                            "vs-row",
                                            [
                                              _c("vs-col", [
                                                _c(
                                                  "ul",
                                                  { staticClass: "columns" },
                                                  _vm._l(
                                                    _vm.occupationCharts,
                                                    function (chart, i) {
                                                      return _c(
                                                        "li",
                                                        {
                                                          key: `occupation-${i}`,
                                                          staticClass:
                                                            "text-primary",
                                                        },
                                                        [
                                                          _c("div", {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip.top-start",
                                                                value: {
                                                                  content:
                                                                    _vm
                                                                      .tooltipDescOccupations[
                                                                      i
                                                                    ],
                                                                },
                                                                expression:
                                                                  "{\n                                                content: tooltipDescOccupations[i],\n                                            }",
                                                                modifiers: {
                                                                  "top-start": true,
                                                                },
                                                              },
                                                            ],
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.formatHtmlTitle(
                                                                  chart
                                                                )
                                                              ),
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _c(
                                      "ul",
                                      { staticClass: "columns" },
                                      _vm._l(
                                        _vm.employee.occupations,
                                        function (occupation, i) {
                                          return _c(
                                            "li",
                                            {
                                              key: `occTitle-${i}`,
                                              staticClass: "text-primary",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                - " +
                                                  _vm._s(occupation.title) +
                                                  "\n                            "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                              _vm._v(" "),
                              _vm.showRatingsHaveOccupations &&
                              _vm.switchOccupationsRadar === "occupations"
                                ? _c(
                                    "vs-row",
                                    { staticClass: "chart-container" },
                                    [
                                      _vm._l(
                                        _vm.occupationCharts,
                                        function (chart, i) {
                                          return [
                                            _c(
                                              "vs-col",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value: {
                                                      content:
                                                        _vm
                                                          .tooltipDescOccupations[
                                                          i
                                                        ],
                                                    },
                                                    expression:
                                                      "{ content: tooltipDescOccupations[i] }",
                                                  },
                                                ],
                                                staticClass: "mt-6 chart",
                                                attrs: {
                                                  "vs-lg": "6",
                                                  "vs-sm": "12",
                                                },
                                              },
                                              [
                                                _c("rating-chart", {
                                                  staticClass: "rating",
                                                  attrs: {
                                                    employee: _vm.employee,
                                                    options: chart.options,
                                                    "chart-data": chart.data,
                                                    id: "chart-occupation-" + i,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm.showRatingsHaveOccupations &&
                                  _vm.switchOccupationsRadar ===
                                    "occupationSkills"
                                ? _c(
                                    "div",
                                    _vm._l(
                                      _vm.occupationCharts,
                                      function (occupationChart, i) {
                                        return _c(
                                          "vs-row",
                                          {
                                            key: `${i}-occupationChart.occupationId`,
                                          },
                                          [
                                            _c("vs-col", [
                                              _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.formatHtmlTitle(
                                                      occupationChart,
                                                      false
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm
                                                .occupationSkillsOccupationCharts[
                                                occupationChart.occupationId
                                              ],
                                              function (osChart, i) {
                                                return [
                                                  _c(
                                                    "vs-col",
                                                    {
                                                      staticClass:
                                                        "mt-6 chart chart-container",
                                                      attrs: {
                                                        "vs-lg": "6",
                                                        "vs-sm": "12",
                                                      },
                                                    },
                                                    [
                                                      _c("rating-chart", {
                                                        staticClass: "rating",
                                                        attrs: {
                                                          employee:
                                                            _vm.employee,
                                                          options:
                                                            osChart.options,
                                                          "chart-data":
                                                            osChart.data,
                                                          id:
                                                            "chart-occupation-" +
                                                            occupationChart.occupationId +
                                                            "-OccSkillIndex-" +
                                                            i,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showRatingsHaveOccupations &&
                              _vm.switchOccupationsRadar ===
                                "occupationSkillsLevels"
                                ? _c(
                                    "vs-row",
                                    { staticClass: "chart-container" },
                                    _vm._l(
                                      _vm.occupationChartsOfOccskills,
                                      function (chart, i) {
                                        return _c(
                                          "vs-col",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: {
                                                  content:
                                                    _vm.tooltipDescJobs[i],
                                                },
                                                expression:
                                                  "{ content: tooltipDescJobs[i] }",
                                              },
                                            ],
                                            key: `chart-occupation-${i}`,
                                            staticClass: "mt-6 chart",
                                            attrs: {
                                              "vs-lg": "6",
                                              "vs-sm": "12",
                                            },
                                          },
                                          [
                                            _c("rating-chart", {
                                              staticClass: "rating",
                                              attrs: {
                                                employee: _vm.employee,
                                                options: chart.options,
                                                "chart-data": chart.data,
                                                id:
                                                  "chart-occupationSkill-" + i,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showRatingsHaveJobs
                        ? _c(
                            "vs-collapse-item",
                            {
                              attrs: {
                                open: _vm.employeeOccupationSkillRatingsOnly,
                                id: "employee-jobs-charts",
                                "icon-arrow": "arrow_downward",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "collapse-header",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "bold text-primary" },
                                    [_vm._v("Expérience(s) : ")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.showRatings.length
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "vs-row",
                                        {
                                          staticClass: "mb-5",
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-w": "12",
                                          },
                                        },
                                        [
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-lg": "2",
                                                "vs-sm": "4",
                                              },
                                            },
                                            [
                                              _c(
                                                "vs-radio",
                                                {
                                                  attrs: {
                                                    id: "switchJobRadio_jobs",
                                                    "vs-name": "switchJobRadio",
                                                    "vs-value": "jobs",
                                                    disabled:
                                                      _vm.employeeOccupationSkillRatingsOnly,
                                                  },
                                                  model: {
                                                    value: _vm.switchJobsRadar,
                                                    callback: function ($$v) {
                                                      _vm.switchJobsRadar = $$v
                                                    },
                                                    expression:
                                                      "switchJobsRadar",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    Accessibilité\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-lg": "2",
                                                "vs-sm": "4",
                                              },
                                            },
                                            [
                                              _c(
                                                "vs-radio",
                                                {
                                                  attrs: {
                                                    id: "switchJobRadio_occupationSkills",
                                                    "vs-name": "switchJobRadio",
                                                    "vs-value":
                                                      "occupationSkills",
                                                    disabled:
                                                      _vm.employeeOccupationSkillRatingsOnly,
                                                  },
                                                  model: {
                                                    value: _vm.switchJobsRadar,
                                                    callback: function ($$v) {
                                                      _vm.switchJobsRadar = $$v
                                                    },
                                                    expression:
                                                      "switchJobsRadar",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    Savoir-faire\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "vs-col",
                                            {
                                              staticClass: "flex",
                                              attrs: {
                                                "vs-lg": "2",
                                                "vs-sm": "4",
                                              },
                                            },
                                            [
                                              _c(
                                                "vs-radio",
                                                {
                                                  attrs: {
                                                    id: "switchJobRadio_occupationSkillsLevels",
                                                    "vs-name": "switchJobRadio",
                                                    "vs-value":
                                                      "occupationSkillsLevels",
                                                  },
                                                  model: {
                                                    value: _vm.switchJobsRadar,
                                                    callback: function ($$v) {
                                                      _vm.switchJobsRadar = $$v
                                                    },
                                                    expression:
                                                      "switchJobsRadar",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    Maîtrise savoir-faire\n                                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "ms-tooltip",
                                                    {
                                                      attrs: {
                                                        text: "Le score de maîtrise est la moyenne des savoir-faire maîtrisés pondérée suivant le niveau de maîtrise",
                                                        position: "right",
                                                      },
                                                    },
                                                    [
                                                      _c("vs-button", {
                                                        staticClass:
                                                          "large-icon",
                                                        attrs: {
                                                          radius: "",
                                                          color: "primary",
                                                          type: "flat",
                                                          icon: "info",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.switchJobsRadar === "jobs"
                                        ? _c(
                                            "vs-row",
                                            [
                                              _c("vs-col", [
                                                _c(
                                                  "ul",
                                                  { staticClass: "columns" },
                                                  _vm._l(
                                                    _vm.jobCharts,
                                                    function (chart, i) {
                                                      return _c(
                                                        "li",
                                                        {
                                                          key: `title-job-${i}`,
                                                          staticClass:
                                                            "text-primary",
                                                        },
                                                        [
                                                          _c("div", {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip.top-start",
                                                                value: {
                                                                  content:
                                                                    _vm
                                                                      .tooltipDescJobs[
                                                                      i
                                                                    ],
                                                                },
                                                                expression:
                                                                  "{\n                                                content: tooltipDescJobs[i],\n                                            }",
                                                                modifiers: {
                                                                  "top-start": true,
                                                                },
                                                              },
                                                            ],
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.formatHtmlTitle(
                                                                  chart
                                                                )
                                                              ),
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _c(
                                      "ul",
                                      { staticClass: "columns" },
                                      _vm._l(
                                        _vm.employee.jobs,
                                        function (job, i) {
                                          return _c(
                                            "li",
                                            {
                                              key: `jobTitle-${i}`,
                                              staticClass: "text-primary",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                - " +
                                                  _vm._s(job.title) +
                                                  "\n                            "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                              _vm._v(" "),
                              _vm.showRatingsHaveJobs &&
                              _vm.switchJobsRadar === "jobs"
                                ? _c(
                                    "vs-row",
                                    { staticClass: "chart-container" },
                                    _vm._l(_vm.jobCharts, function (chart, i) {
                                      return _c(
                                        "vs-col",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: {
                                                content: _vm.tooltipDescJobs[i],
                                              },
                                              expression:
                                                "{ content: tooltipDescJobs[i] }",
                                            },
                                          ],
                                          key: `chart-job-${i}`,
                                          staticClass: "mt-6 chart",
                                          attrs: {
                                            "vs-lg": "6",
                                            "vs-sm": "12",
                                          },
                                        },
                                        [
                                          _c("rating-chart", {
                                            staticClass: "rating",
                                            attrs: {
                                              employee: _vm.employee,
                                              options: chart.options,
                                              "chart-data": chart.data,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                : _vm.showRatingsHaveJobs &&
                                  _vm.switchJobsRadar === "occupationSkills"
                                ? _c(
                                    "div",
                                    _vm._l(
                                      _vm.jobCharts,
                                      function (jobChart, i) {
                                        return _c(
                                          "vs-row",
                                          { key: `${i}-jobChart.jobId` },
                                          [
                                            _c("vs-col", [
                                              _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.formatHtmlTitle(
                                                      jobChart
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.occupationSkillsJobCharts[
                                                jobChart.jobId
                                              ],
                                              function (osChart, i) {
                                                return _c(
                                                  "vs-col",
                                                  {
                                                    key: `chart-os-${i}-${jobChart.jobId}`,
                                                    staticClass:
                                                      "mt-6 chart chart-container",
                                                    attrs: {
                                                      "vs-lg": "6",
                                                      "vs-sm": "12",
                                                    },
                                                  },
                                                  [
                                                    _c("rating-chart", {
                                                      staticClass: "rating",
                                                      attrs: {
                                                        employee: _vm.employee,
                                                        options:
                                                          osChart.options,
                                                        "chart-data":
                                                          osChart.data,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showRatingsHaveJobs &&
                              _vm.switchJobsRadar === "occupationSkillsLevels"
                                ? _c(
                                    "vs-row",
                                    { staticClass: "chart-container" },
                                    _vm._l(
                                      _vm.jobChartsOfOccskills,
                                      function (chart, i) {
                                        return _c(
                                          "vs-col",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: {
                                                  content:
                                                    _vm.tooltipDescJobs[i],
                                                },
                                                expression:
                                                  "{ content: tooltipDescJobs[i] }",
                                              },
                                            ],
                                            key: `chart-job-${i}`,
                                            staticClass: "mt-6 chart",
                                            attrs: {
                                              "vs-lg": "6",
                                              "vs-sm": "12",
                                            },
                                          },
                                          [
                                            _c("rating-chart", {
                                              staticClass: "rating",
                                              attrs: {
                                                employee: _vm.employee,
                                                options: chart.options,
                                                "chart-data": chart.data,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.wishOccupationCharts &&
                      _vm.wishOccupationCharts.length
                        ? _c(
                            "vs-collapse-item",
                            {
                              attrs: {
                                open: false,
                                id: "employee-wishlist-occupations-charts",
                                "icon-arrow": "arrow_downward",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "collapse-header",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "bold text-primary" },
                                    [_vm._v("Métier(s) souhaité(s) : ")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "columns" },
                                _vm._l(
                                  _vm.wishOccupationCharts,
                                  function (chart, i) {
                                    return _c(
                                      "li",
                                      {
                                        key: `title-wish-occupation-${i}`,
                                        staticClass: "text-primary",
                                      },
                                      [
                                        _c("div", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip.top-start",
                                              value: {
                                                content:
                                                  _vm
                                                    .tooltipDescWishOccupations[
                                                    i
                                                  ],
                                              },
                                              expression:
                                                "{\n                                    content: tooltipDescWishOccupations[i],\n                                }",
                                              modifiers: { "top-start": true },
                                            },
                                          ],
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.formatHtmlTitle(chart)
                                            ),
                                          },
                                        }),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                              _vm._v(" "),
                              _vm.wishOccupationCharts
                                ? _c(
                                    "vs-row",
                                    _vm._l(
                                      _vm.wishOccupationCharts,
                                      function (chart, i) {
                                        return _c(
                                          "vs-col",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: {
                                                  content:
                                                    _vm
                                                      .tooltipDescWishOccupations[
                                                      i
                                                    ],
                                                },
                                                expression:
                                                  "{\n                                content: tooltipDescWishOccupations[i],\n                            }",
                                              },
                                            ],
                                            key: `chart-wish-occupation-${i}`,
                                            staticClass: "mt-6 chart",
                                            attrs: {
                                              "vs-lg": "6",
                                              "vs-sm": "12",
                                            },
                                          },
                                          [
                                            _c("rating-chart", {
                                              staticClass: "rating",
                                              attrs: {
                                                employee: _vm.employee,
                                                options: chart.options,
                                                "chart-data": chart.data,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.wishJobCharts && _vm.wishJobCharts.length
                        ? _c(
                            "vs-collapse-item",
                            {
                              attrs: {
                                open: false,
                                id: "employee-wishlist-jobs-charts",
                                "icon-arrow": "arrow_downward",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "collapse-header",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c("p", { staticClass: "bold text-primary" }),
                                  _vm._v("Expérience(s) souhaitée(s) : "),
                                  _c("p"),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "columns" },
                                _vm._l(_vm.wishJobCharts, function (chart, i) {
                                  return _c(
                                    "li",
                                    {
                                      key: `title-wish-job-${i}`,
                                      staticClass: "text-primary",
                                    },
                                    [
                                      _c("div", {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip.top-start",
                                            value: {
                                              content:
                                                _vm.tooltipDescWishJobs[i],
                                            },
                                            expression:
                                              "{\n                                    content: tooltipDescWishJobs[i],\n                                }",
                                            modifiers: { "top-start": true },
                                          },
                                        ],
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.formatHtmlTitle(chart)
                                          ),
                                        },
                                      }),
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _vm.wishJobCharts
                                ? _c(
                                    "vs-row",
                                    _vm._l(
                                      _vm.wishJobCharts,
                                      function (chart, i) {
                                        return _c(
                                          "vs-col",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: {
                                                  content:
                                                    _vm.tooltipDescWishJobs[i],
                                                },
                                                expression:
                                                  "{ content: tooltipDescWishJobs[i] }",
                                              },
                                            ],
                                            key: `chart-wjob-${i}`,
                                            staticClass: "mt-6 chart",
                                            attrs: {
                                              "vs-lg": "6",
                                              "vs-sm": "12",
                                            },
                                          },
                                          [
                                            _c("rating-chart", {
                                              staticClass: "rating",
                                              attrs: {
                                                employee: _vm.employee,
                                                options: chart.options,
                                                "chart-data": chart.data,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedExternalRatings.length > 0 ||
                      _vm.selectedMobilityRatings.length > 0
                        ? _c(
                            "vs-collapse-item",
                            {
                              attrs: {
                                id: "employee-comments",
                                open: false,
                                "icon-arrow": "arrow_downward",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "collapse-header pl-0",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "bold text-primary" },
                                    [
                                      _vm._v(
                                        "Commentaires des évaluations et auto-évaluations portail :"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "vs-row",
                                [
                                  _vm._l(
                                    _vm.selectedExternalRatings,
                                    function (ser, i) {
                                      return [
                                        _c(
                                          "vs-col",
                                          {
                                            attrs: {
                                              "vs-lg": "5",
                                              "vs-sm": "12",
                                            },
                                          },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                class: [
                                                  "font-weight-bold",
                                                  i != 0 ? "mt-5" : "",
                                                ],
                                              },
                                              [_vm._v(_vm._s(ser.title))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "pl-5" },
                                              [
                                                Object.keys(ser.comment)
                                                  .length > 0
                                                  ? _vm._l(
                                                      Object.keys(ser.comment),
                                                      function (
                                                        commentName,
                                                        j
                                                      ) {
                                                        return _c("div", [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "mt-3 text-primary",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getQuestionLabelFromSlug(
                                                                    commentName
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "pl-3 text-dark",
                                                            },
                                                            [
                                                              ser.comment[
                                                                commentName
                                                              ]
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ser
                                                                          .comment[
                                                                          commentName
                                                                        ]
                                                                      )
                                                                    ),
                                                                  ])
                                                                : _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-dark",
                                                                      staticStyle:
                                                                        {
                                                                          opacity:
                                                                            "0.6",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                    Aucun commentaire disponible.\n                                                "
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ]
                                                          ),
                                                        ])
                                                      }
                                                    )
                                                  : [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-dark",
                                                          staticStyle: {
                                                            opacity: "0.6",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Aucun commentaire disponible."
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ]
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.selectedMobilityRatings,
                                    function (ser, i) {
                                      return [
                                        _c(
                                          "vs-col",
                                          {
                                            attrs: {
                                              "vs-lg": "5",
                                              "vs-sm": "12",
                                            },
                                          },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                class: [
                                                  "font-weight-bold",
                                                  i != 0 ? "mt-5" : "",
                                                ],
                                              },
                                              [_vm._v(_vm._s(ser.title))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "pl-5 mb-10" },
                                              [
                                                Object.keys(ser.comment)
                                                  .length > 0
                                                  ? _vm._l(
                                                      Object.keys(ser.comment),
                                                      function (
                                                        commentName,
                                                        j
                                                      ) {
                                                        return _c("div", [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "mt-3 text-primary",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getQuestionLabelFromSlug(
                                                                    commentName
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "pl-3 text-dark",
                                                            },
                                                            [
                                                              ser.comment[
                                                                commentName
                                                              ]
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ser
                                                                          .comment[
                                                                          commentName
                                                                        ]
                                                                      )
                                                                    ),
                                                                  ])
                                                                : _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-dark",
                                                                      staticStyle:
                                                                        {
                                                                          opacity:
                                                                            "0.6",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                    Aucun commentaire disponible.\n                                                "
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ]
                                                          ),
                                                        ])
                                                      }
                                                    )
                                                  : [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-dark",
                                                          staticStyle: {
                                                            opacity: "0.6",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Aucun commentaire disponible."
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.exportPDF
            ? _c("export-ratings-pdf", {
                attrs: {
                  employee: _vm.employee,
                  skillRatingChart: _vm.skillRatingChartForExport,
                  autoEvalChart: _vm.autoEvalChartForExport,
                  occupationCharts: _vm.occupationChartsForExport,
                  jobCharts: _vm.jobChartsForExport,
                  jobs: _vm.jobs,
                  wishOccupationCharts: _vm.wishOccupationChartsForExport,
                  wishJobCharts: _vm.wishJobChartsForExport,
                  concernedRating: _vm.exportRatings[0],
                },
                on: { exported: _vm.closeExport },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }